module.exports = __webpack_public_path__ + "img/resize_big.1cad3532.svg";